import React from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from '@material-ui/core/styles';

const Article = () => {
  const theme = useTheme();

  return (
    <div style={{ marginTop: -90 }}>
      <ContentLoader
        width="100%"
        height={160}
        speed={2}
        backgroundColor={theme.palette.type === 'light' ? '#eaeced' : '#424242'}
        foregroundColor={theme.palette.type === 'light' ? '#ffffff' : '#E0E0E0'}
      >
        <rect x="0" y="99" rx="5" ry="5" width="100%" height="200" />
      </ContentLoader>
    </div>
  );
};

export default Article;
